import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { Maintenance } from '../../model/maintenance-http.model';
import { API_ROUTE_MAINTENANCE, getPublicApiUrl } from '../../app.constants';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService extends ApiService {
  fetchMaintenanceMode(): Observable<Maintenance> {
    return this.httpClient.get<Maintenance>(getPublicApiUrl(this.apiUrl, API_ROUTE_MAINTENANCE));
  }
}
